/**
 * Сигнал «відкрити попап подарунка на день народження» (owner 2026-09-13).
 * Той самий підхід, що у промо-подарунка: банер і диплінк просто кличуть
 * `openBirthdayGift()`, а портал у App.tsx малює попап.
 */
let open = false;
const subs = new Set<(v: boolean) => void>();

export function openBirthdayGift(): void {
  open = true;
  subs.forEach((f) => f(true));
}

export function closeBirthdayGift(): void {
  open = false;
  subs.forEach((f) => f(false));
}

export function isBirthdayGiftOpen(): boolean {
  return open;
}

export function subscribeBirthdayGift(fn: (v: boolean) => void): () => void {
  subs.add(fn);
  return () => subs.delete(fn);
}
